export default function getSwitchExchangetoken(url: string) {
  // Extract the query part of the URL
  const queryString = url.split('?')[1];

  // Parse the query parameters
  const params = new URLSearchParams(queryString);

  // Get the value of 'switch_exchange_token'
  const switchExchangeToken = params.get('switch_exchange_token');
  return switchExchangeToken;
}
